// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import { Col } from '../../../col/Col'
import { Container } from '../../../container/Container'
import { Icon } from '../../../icon/Icon'
import { Link } from '../../../link/Link'
import { H } from '../../../h/H'
import { HeaderOverlay } from '../../overlay/HeaderOverlay'
import { Row } from '../../../row/Row'
import { P } from '../../../p/P'

// Interfaces
import { IRegion } from '../../../../../interfaces/IRegion'

@Component({
    mixins: [
        template,
    ],
    components: {
        Col,
        Container,
        Icon,
        Link,
        H,
        HeaderOverlay,
        Row,
        P,
    }
})
export class Regions extends Vue {

    public get assetsUrl() {
        return APP_ASSETS_URL
    }
    
    private get selectedRegion() {

        if (!this.ausgewahlteRegionId) return false

        const region = this.regions.find(region => region.id == this.ausgewahlteRegionId)

        return region!
    }

    private get selectedRegionLaender() {

        if (!this.ausgewahlteRegionId) return false

        const region = this.regions.find(region => region.id == this.ausgewahlteRegionId)

        return region!.laender.slice()

    }

    private ausgewahlteRegionId: number | null = null

    @Prop()
    public activeOverlayInternal!: string

    @Prop()
    public regions!: IRegion[]

    @Prop()
    public currentRegion!: string

    public created () {

       
    }

    public destroyed() {
        
    }

    private handleCloseRegionenOverlay() {

        this.handleClose()
        this.handleRegionUnselect()
    }

    private handleRegionSelect(regionId: number) {
        this.ausgewahlteRegionId = regionId
    }

    private handleRegionUnselect() {
        this.ausgewahlteRegionId = null
    }

    private handleCountrySelect(country: any) {
        this.$emit('change-country', country)
    }

    private handleOpen() {
        this.$emit('open')
    }

    private handleClose() {
        this.$emit('close')
        this.handleRegionUnselect()
    }

    public get alleLaender() {
        return this.regions.flatMap(r => r.laender.slice());
    }

    public get currentRegionName() {
        if (this.currentRegion == "GLOBAL") {
            return this.$t('HEADER_REGIONEN_TITLE_INTERNATIONAL')
        } else if (this.currentRegion && this.alleLaender && this.alleLaender.length > 0) {
            let region = this.alleLaender.find(l => l.krzl == this.currentRegion);
            if (region) {
                return region.name;
            }
        }

        return this.$t('HEADER_REGIONEN_TITLE');
    }
}